export const translations = {
  'sv': {
    searchlabel: 'Sök',
    searchplaceholder: 'Vad letar du efter?',
    searchbuttontext: 'Sök',
    menuHomeButton: 'Hem',
    menuGoBackButton: 'Gå tillbaka',
    mainMenuButton: 'Meny',
    menuStartButton: 'Start',
    profileSelectionFlyoutHeading: 'Inloggad som',
    unifiedLoginButton: 'Logga in',
    unifiedMyPagesButton: 'Mina sidor',
    home: 'Hem',
  },
  'en': {
    searchlabel: 'Search',
    searchplaceholder: 'Search',
    searchbuttontext: 'Search',
    menuHomeButton: 'Home',
    menuGoBackButton: 'Go back',
    mainMenuButton: 'Menu',
    menuStartButton: 'Start',
    profileSelectionFlyoutHeading: 'Logged in as',
    unifiedLoginButton: 'Log in',
    unifiedMyPagesButton: 'My pages',
    home: 'Home',
  },
  'da': {
    searchlabel: 'Søg',
    searchplaceholder: 'Søg',
    searchbuttontext: 'Søg',
    menuHomeButton: 'Hjem',
    menuGoBackButton: 'Gå tilbage',
    mainMenuButton: 'Menu',
    menuStartButton: 'Start',
    profileSelectionFlyoutHeading: 'Logget ind som',
    unifiedLoginButton: 'Log ind',
    unifiedMyPagesButton: 'Mine sider',
    home: 'Hjem',
  },
  'no': {
    searchlabel: 'Søk',
    searchplaceholder: 'Søk',
    searchbuttontext: 'Søk',
    menuHomeButton: 'Hjem',
    menuGoBackButton: 'Gå tilbake',
    mainMenuButton: 'Meny',
    menuStartButton: 'Start',
    profileSelectionFlyoutHeading: 'Logget på som',
    unifiedLoginButton: 'Logg inn',
    unifiedMyPagesButton: 'Sidene mine',
    home: 'Hjem',
  },
  'fi': {
    searchlabel: 'Hae',
    searchplaceholder: 'Hae',
    searchbuttontext: 'Hae',
    menuHomeButton: 'Koti',
    menuGoBackButton: 'Mene takaisin',
    mainMenuButton: 'Valikko',
    menuStartButton: 'Alkaa',
    profileSelectionFlyoutHeading: 'Kirjautunut sisään nimellä',
    unifiedLoginButton: 'Kirjaudu sisään',
    unifiedMyPagesButton: 'Minun sivujani',
    home: 'Koti',
  },
  'de': {
    searchlabel: 'Suche',
    searchplaceholder: 'Wonach suchen Sie?',
    searchbuttontext: 'Suche',
    menuHomeButton: 'Start',
    menuGoBackButton: 'Geh zurück',
    mainMenuButton: 'Menü',
    menuStartButton: 'Start',
    profileSelectionFlyoutHeading: 'Eingeloggt als',
    unifiedLoginButton: 'Anmeldung',
    unifiedMyPagesButton: 'Meine Seiten',
    home: 'Start',
  },
  'zh': {
    searchlabel: '搜索',
    searchplaceholder: '搜索',
    searchbuttontext: '搜索',
    menuHomeButton: '主页',
    menuGoBackButton: '回去',
    mainMenuButton: '选择菜单',
    menuStartButton: '开始',
    home: '主页',
  },
  'it': {
    searchlabel: 'Cerca',
    searchplaceholder: 'Cerca',
    searchbuttontext: 'Cerca',
    menuHomeButton: 'Home',
    menuGoBackButton: 'Go back',
    mainMenuButton: 'Menu',
    menuStartButton: 'Start',
    profileSelectionFlyoutHeading: 'Logged in as',
    unifiedLoginButton: 'Log in',
    unifiedMyPagesButton: 'My pages',
    home: 'Home',

  },
  'nl': {
    searchlabel: 'Zoeken',
    searchplaceholder: 'Zoeken',
    searchbuttontext: 'Zoeken',
    menuHomeButton: 'Home',
    menuGoBackButton: 'Go back',
    mainMenuButton: 'Menu',
    menuStartButton: 'Start',
    profileSelectionFlyoutHeading: 'Logged in as',
    unifiedLoginButton: 'Log in',
    unifiedMyPagesButton: 'My pages',
    home: 'Home',
  },
  'es': {
    searchplaceholder: 'Buscar',
    searchlabel: 'Buscar',
    searchbuttontext: 'Buscar',
    menuHomeButton: 'Inicio',
    menuGoBackButton: 'Go back',
    mainMenuButton: 'Menu',
    menuStartButton: 'Start',
    profileSelectionFlyoutHeading: 'Logged in as',
    unifiedLoginButton: 'Log in',
    unifiedMyPagesButton: 'My pages',
    home: 'Inicio',
  },
  'fr': {
    searchplaceholder: 'Recherche',
    searchlabel: 'Recherche',
    searchbuttontext: 'Recherche',
    menuHomeButton: 'Accueil',
    menuGoBackButton: 'Go back',
    mainMenuButton: 'Menu',
    menuStartButton: 'Start',
    profileSelectionFlyoutHeading: 'Logged in as',
    unifiedLoginButton: 'Log in',
    unifiedMyPagesButton: 'My pages',
    home: 'Accueil',
  },
  'tr': {
    searchlabel: 'Ara',
    searchplaceholder: 'Ara',
    searchbuttontext: 'Ara',
    menuHomeButton: 'Anasayfa',
    menuGoBackButton: 'Geri git',
    mainMenuButton: 'Menü',
    menuStartButton: 'Başlat',
    profileSelectionFlyoutHeading: 'Oturum açma adı',
    unifiedLoginButton: 'Oturum aç',
    unifiedMyPagesButton: 'Sayfalarım',
    home: 'Anasayfa',
  },
  'pt': {
    searchlabel: 'Search',
    searchplaceholder: 'Search',
    searchbuttontext: 'Search',
    menuHomeButton: 'Página inicial',
    menuGoBackButton: 'Go back',
    mainMenuButton: 'Menu',
    menuStartButton: 'Start',
    profileSelectionFlyoutHeading: 'Logged in as',
    unifiedLoginButton: 'Log in',
    unifiedMyPagesButton: 'My pages',
  },
  'pl': {
    searchlabel: 'Szukaj',
    searchplaceholder: 'Szukaj',
    searchbuttontext: 'Szukaj',
    menuHomeButton: 'Strona główna',
    menuGoBackButton: 'Powrót',
    mainMenuButton: 'Menu',
    menuStartButton: 'Początek',
    profileSelectionFlyoutHeading: 'Zalogowany(-a) jako',
    unifiedLoginButton: 'Logowanie',
    unifiedMyPagesButton: 'Moje strony',
    home: 'Strona główna',
  },
  'pt-BR': {
    searchlabel: 'Buscar',
    searchplaceholder: 'Buscar',
    searchbuttontext: 'Buscar',
    menuHomeButton: 'Página inicial',
    menuGoBackButton: 'Voltar',
    mainMenuButton: 'Menu',
    menuStartButton: 'Iniciar',
    profileSelectionFlyoutHeading: 'Login efetuado como',
    unifiedLoginButton: 'Fazer login',
    unifiedMyPagesButton: 'Minhas páginas',
  },
};
